// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"326ee264","148":"1384e285","152":"bd944a7a","226":"6603aa81","302":"193be28a","371":"210e08ca","485":"cb4be99a","509":"aceff0a0","636":"3186a7bd","679":"3500b8b2","869":"1af8e644"}[chunkId] + ".chunk.js";
};